type Lvl = { price: number; shares: number; total: number };
type Book = { yesBids: Lvl[]; yesAsks: Lvl[]; bestBid: number; bestAsk: number; spread: number | null; mid: number };

export function OrderBook({ book }: { book: Book }) {
  const max = Math.max(1, ...book.yesAsks.map((l) => l.shares), ...book.yesBids.map((l) => l.shares));
  return (
    <div>
      <div className="mkt-meta" style={{ marginBottom: 8 }}>
        <span>Best bid {book.bestBid || "—"}¢</span>
        <span>Best ask {book.bestAsk || "—"}¢</span>
        <span>Spread {book.spread ?? "—"}¢</span>
        <span>Mid {book.mid}¢</span>
      </div>
      <div className="book">
        <div>
          <strong>YES asks</strong>
          {[...book.yesAsks].reverse().map((l) => (
            <div className="book-row" key={`a${l.price}`}>
              <div className="depth ask" style={{ width: `${(l.shares / max) * 100}%`, marginLeft: "auto" }} />
              <span style={{ color: "var(--danger)" }}>{l.price}¢</span>
              <span>{l.shares.toLocaleString()}</span>
              <span>{l.total.toLocaleString()}</span>
            </div>
          ))}
        </div>
        <div>
          <strong>YES bids</strong>
          {book.yesBids.map((l) => (
            <div className="book-row" key={`b${l.price}`}>
              <div className="depth bid" style={{ width: `${(l.shares / max) * 100}%` }} />
              <span style={{ color: "var(--success)" }}>{l.price}¢</span>
              <span>{l.shares.toLocaleString()}</span>
              <span>{l.total.toLocaleString()}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
